import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';

import { Observable, Subject } from 'rxjs';
import { environment } from 'src/environments/environment';
@Injectable({
  providedIn: 'root'
})
export class ServiceService {
  filters$: Observable<any>;
  data$: Observable<any>;
  private logData = new Subject<any>();
  private filtersSubject = new Subject<any>();
  constructor(private Http: HttpClient) { 
    this.filters$ = this.filtersSubject.asObservable();
    this.data$ = this.logData.asObservable();
  }

  userLogin(form) {
    return this.Http.post(`${environment.lectrixUrl}v1/vehicle/login`, form)
      .pipe(
        ((response: any) => {
          const data = response;
          return data;
        }))
  }

  addUser(form){
  
      let header = new HttpHeaders().set(
        "Authorization", sessionStorage.getItem("token")
      );
      return this.Http.post(`${environment.lectrixUrl}v1/vehicle/addVehicles`,form , { headers: header })
        .pipe(
          ((response: any) => {
            const data = response;
            return data;
          }))
    }

    addTryBuyUser(form){
  
      let header = new HttpHeaders().set(
        "Authorization", sessionStorage.getItem("token")
      );
      return this.Http.post(`${environment.lectrixUrl}v1/vehicle/addUser`,form , { headers: header })
        .pipe(
          ((response: any) => {
            const data = response;
            return data;
          }))
    }

    removeAccess(form){
  
      let header = new HttpHeaders().set(
        "Authorization", sessionStorage.getItem("token")
      );
      return this.Http.post(`${environment.lectrixUrl}v1/vehicle/removeAccess`,form , { headers: header })
        .pipe(
          ((response: any) => {
            const data = response;
            return data;
          }))
    }

    getVehicleData() {
      let header = new HttpHeaders().set(
        "Authorization", sessionStorage.getItem("token")
      );
      return this.Http.get(`${environment.lectrixUrl}v1/vehicle/getVehicles`, { headers: header })
        .pipe(
          ((response: any) => {
            const data = response;
            return data;
          }))
    }
    
getVehicleList(data){
  let header = new HttpHeaders().set(
    "Authorization", sessionStorage.getItem("token")
  );
  return this.Http.get(`${environment.lectrixUrl}v1/vehicle/dropdown/`+ data, { headers: header })
    .pipe(
      ((response: any) => {
        const data = response;
        return data;
      }))
}


  }
